import React from 'react';
import PropTypes from 'prop-types';
import { educationLevels } from '../../copy/educationLevels';

const SomeCollegeIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 774.46 1000"
      role="img"
    >
      <title>{educationLevels().level4.label}</title>
      <path
        d="M883.79,174.88c-.06,0-.08-.13-.14-.18L698.29,3.71A12.49,12.49,0,0,0,689.81.4H125.71a12.5,12.5,0,0,0-12.5,12.5v975a12.5,12.5,0,0,0,12.5,12.5H875.18a12.5,12.5,0,0,0,12.5-12.5v-804a12.43,12.43,0,0,0-1-4.95c-.14-.3-.4-.52-.55-.82A12.4,12.4,0,0,0,883.79,174.88ZM702.31,41.43l140.88,130H702.31Zm-564.1,934V25.4h539.1V183.88a12.5,12.5,0,0,0,12.5,12.5H862.68v779Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M255.93,144.15h255.3a12.5,12.5,0,0,0,0-25H255.93a12.5,12.5,0,0,0,0,25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M255.93,230.41h255.3a12.5,12.5,0,0,0,0-25H255.93a12.5,12.5,0,0,0,0,25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,346H438.86a12.5,12.5,0,0,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,444H438.86a12.5,12.5,0,0,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M353.24,346h-98a12.5,12.5,0,0,0-12.5,12.5v98A12.5,12.5,0,0,0,255.2,469h98a12.5,12.5,0,0,0,12.5-12.5v-98A12.5,12.5,0,0,0,353.24,346Zm-12.5,98h-73V371h73Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,531.76H438.86a12.5,12.5,0,0,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,629.8H438.86a12.5,12.5,0,1,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M353.24,531.76h-98a12.5,12.5,0,0,0-12.5,12.5v98a12.5,12.5,0,0,0,12.5,12.5h98a12.5,12.5,0,0,0,12.5-12.5v-98A12.5,12.5,0,0,0,353.24,531.76Zm-12.5,98h-73v-73h73Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,717.52H438.86a12.5,12.5,0,0,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M748.05,815.56H438.86a12.5,12.5,0,0,0,0,25H748a12.5,12.5,0,0,0,0-25Z"
        transform="translate(-113.21 -0.4)"
      />
      <path
        d="M353.24,717.52h-98A12.5,12.5,0,0,0,242.7,730v98a12.5,12.5,0,0,0,12.5,12.5h98a12.5,12.5,0,0,0,12.5-12.5V730A12.5,12.5,0,0,0,353.24,717.52Zm-12.5,98h-73v-73h73Z"
        transform="translate(-113.21 -0.4)"
      />
    </svg>
  );
};

export default SomeCollegeIcon;

SomeCollegeIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
